import React from 'react';
import './ui.css';

export type PillStatus = 'running' | 'idle' | 'error' | 'disabled' | 'warning';

export const StatusPill: React.FC<{ status: PillStatus; label?: string }> = ({ status, label }) => (
  <span className={`ui-pill ui-pill--${status}`}>{label ?? status}</span>
);
